<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'

import { useBlogStore } from '~/js/stores/_fiftyfiveplus/blogs'

import { getGlobalTranslation } from '~/js/composables/_fiftyfiveplus/translations'
import { useSetQueryParams } from '~/js/composables/_fiftyfiveplus/query-parameters'

import { Category } from '~/js/interfaces/_fiftyfiveplus/job'

import AlertNoResults from '~/vue/__fiftyfiveplus/_molecules/alerts/AlertNoResults.vue'
import Filter from '~/vue/__fiftyfiveplus/_organisms/filters/FilterBlogs.vue'
import TextH4 from '~/vue/__fiftyfiveplus/_atoms/texts/TextH4.vue'
import Card from '~/vue/__fiftyfiveplus/_molecules/cards/CardBlog.vue'
import Skeleton from '~/vue/__fiftyfiveplus/_molecules/skeletons/SkeletonBlog.vue'
import ButtonSecondary from '~/vue/__fiftyfiveplus/_atoms/buttons/ButtonSecondary.vue'

interface Type {
    type: string,
    title: string
}

interface Props {
    types: Array<Type>
    sectorCategories?: Array<Category> | null,
}

withDefaults(defineProps<Props>(), {
    sectorCategories: null,
})

const blogsStore = useBlogStore()
const { blogs, loading, pagination } = storeToRefs(blogsStore)

const loadingMore = ref(false)

const onLoadMore = () => {
    loadingMore.value = true
    blogsStore.fetch(false)
}

watch(loading, (val) => {
    if (!val) loadingMore.value = false
})

onMounted(async () => {
    const queryParameters = useSetQueryParams()

    blogsStore.setItemsPerPage(6)
    blogsStore.fetch(true, false, queryParameters)
})
</script>

<template>
    <section class="relative overflow-hidden">

        <div class="max-w-screen-xl mx-auto w-full container space-y-6 lg:space-y-11 pb-14">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 relative">
                <Card
                    v-if="blogs && !loading"
                    v-for="(post, i) in blogs.map(post => post.document)"
                    :card="post"
                />
                <template v-if="loadingMore && blogs">
                    <Card
                        v-for="(post, i) in blogs.map(post => post.document)"
                        :card="post"
                    />
                    <Skeleton
                        v-for="i in pagination.itemsPerPage"
                        :key="'more-' + i"
                    />
                </template>
                <Skeleton
                    v-if="loading && !loadingMore"
                    v-for="i in pagination.itemsPerPage"
                    :key="i"
                />
                <AlertNoResults v-if="blogs && blogs.length === 0 && !loading" />
            </div>
            <ButtonSecondary
                v-if="!loading && (pagination.current < pagination.totalPages && pagination.current != pagination.totalPages)"
                utilities="mx-auto !block mt-4"
                type="button"
                :content="getGlobalTranslation('Toon meer resultaten')"
                @click="onLoadMore"
            />
        </div>
    </section>
</template>
